//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {  GetCommodityListByBanner } from './../../service/index'
// import { go } from './../../util/router'
import MultiSelect from '@/components/MultiSelect'
export default {
  name: 'hello',
  components:{
    MultiSelect
  },
  data () {
    return {
      CommodityList: [],
      pageNum: 0,
      pageSize: 10,
      isLock: false,
      noMore: false,
      otype: '',// 现货抢购|现货选配|其他

      SortType: null // 排序方式，0销量降序
    }
  },
  created () {
    this.UpdataRouteParam()
  },
  mounted () {
    this.pagescroll()
  },
  watch: {
    $route: function(to, from) {
      // console.log('****监控路由，刷新页面*****',to.name,from.name)
      if (to.name === 'banner' && from.name === 'home1') {
        this.pageNum = 0
        this.noMore = false
        this.CommodityList = []
        setTimeout(()=>{
          this.$refs.Multi.Reset()
          this.$refs.Multi.KeyWord = ''
          this.$refs.Multi.searchData()
        },0)
      }
      if (to.name === 'banner') {
        this.UpdataRouteParam()
        this.pagescroll();
      }
    }
  },
  methods: {
    LoadData(res,isSearch){
      console.log(res,isSearch)
      if(isSearch){
        this.pageNum = 0
        this.noMore = false
        this.CommodityList = []
        return
      }
      if (res.code === '1') {
        // let tag = JSON.parse(res.tag);
        // this.pageCount = Number(tag.Dict.records);
        let data = JSON.parse(res.data);
        if(data.length==0&&this.pageNum>0){
          this.noMore = true
          return
        }
        this.CommodityList = [...this.CommodityList,...data]
        if(data.length<this.pageSize&&this.CommodityList.length>0){
          this.noMore = true
        }
      }
      this.isLock = false
    },
    UpdataRouteParam(){
      console.log('<<<<<路由信息>>>>',this.$route)
      this.otype = this.$route.query.otype
      document.title = this.$route.query.bannerName;
      if(this.$route.query.bannerName == '畅销专区'){
        this.SortType = 0
      }

      this.MARA_MTART = this.$route.query.MARA_MTART
      this.bannerOid = this.$route.query.bannerOId
      this.bannerName = this.$route.query.bannerName
    },
    doDetail (oid) {
      this.$router.push({ 
        path: '/Detail/' + oid, query: { 
          otype: this.otype,
          bannerOId: this.bannerOid //专区id
        }
      }) 
    },
    pagescroll () {
      window.onscroll = () => {
        let body = document.body;
        let scrollTop = body.scrollTop === 0 ? document.documentElement.scrollTop : body.scrollTop;
        let dHeight = body.scrollHeight;
        let height = document.documentElement.clientHeight;
        // console.log(scrollTop + '|' + dHeight + '｜' + height)
        if (scrollTop + height >= dHeight - 100) {
          if (this.isLock) return
          this.isLock = true;
          this.pageNum += 1;
          // props传值延迟？？
          setTimeout(() =>{this.$refs.Multi.searchData()}, 0);
        }
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/home/banner.vue